import { render } from "./FichaDoPeixe.vue?vue&type=template&id=62c7c885&scoped=true"
import script from "./FichaDoPeixe.vue?vue&type=script&lang=js"
export * from "./FichaDoPeixe.vue?vue&type=script&lang=js"

import "./FichaDoPeixe.vue?vue&type=style&index=0&id=62c7c885&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62c7c885"]])

export default __exports__